import { gql } from 'graphql-tag';

export const GET_PAYABLE = gql`
  query Id286b361e97759a8a3a3217bf537e76fb($payableId: ID!) {
    __typename
  }
`;
